<template>
  <template v-if="mobile">
    <v-col :reverse="reverse">
      <v-row
        xs6
        :class="{'ml-3': !mobile && reverse, 'mr-3': !mobile && !reverse}"
      >
        <slot name="first" />
      </v-row>

      <v-row
        xs6
        :class="{'mr-3': !mobile && reverse, 'ml-3': !mobile && !reverse}"
      >
        <slot name="second" />
      </v-row>
    </v-col>
  </template>
  <template v-else>
    <v-row
      :reverse="reverse"
      :column="mobile"
      :row="!mobile"
    >
      <v-col
        xs6
        :class="{'ml-3': !mobile && reverse, 'mr-3': !mobile && !reverse}"
      >
        <slot name="first" />
      </v-col>

      <v-col
        xs6
        :class="{'mr-3': !mobile && reverse, 'ml-3': !mobile && !reverse}"
      >
        <slot name="second" />
      </v-col>
    </v-row>
  </template>
</template>

<script>
  export default {
    props: {
      reverse: Boolean
    },
    computed: {
      mobile () {
        return this.$vuetify.display.xs
      }
    }
  }
</script>
